import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { HttpService } from "../http.service";

interface Wallet {
  total_incoming_amount: number;
  total_outgoing_amount: number;
}
interface ZoneData {
  [key: string]: number;
}

interface UnionData {
  [key: string]: number;
}

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  dashboard_details: any;
  no_of_orders_tc: any;
  totalLitersMilk: number = 0;
  totalLitersCurd: number = 0;
  totalLitersByproduct: number = 0;
  walletData: {
    total_amount_credited: number;
    total_amount_debited: number;
  } | null = null;
  productcurdtLitres: { product: string; litres: any }[];
  formBuilder: any;
  myForm: any;
  dateOptions = ["Today", "Yesterday"];
  selectedDate = new FormControl("selectedDate");
  isToday: boolean = true;
  buttonText: string = "Show Yesterday's Report";
  headerText: string = "Today's Summary Report";

  get totalMilkLiters(): number {
    return this.productLitres.reduce((total, item) => total + item.litres, 0);
  }
  get totalCurdLiters(): number {
    return this.productCurdLitres.reduce(
      (total, item) => total + item.litres,
      0
    );
  }
  get totalByProductLiters(): number {
    return this.byProductData.reduce(
      (total, item) => total + parseFloat(item.litres),
      0
    );
  }

  no_of_agents_tc: any;
  no_of_ex_employee_tc: any;
  no_of_employee_tc: any;
  no_of_cardcust_tc: any;
  productLitres: { product: string; litres: number }[] = [];
  productCurdLitres: { product: string; litres: number }[] = [];
  productByproductLitres: { product: string; litres: any }[];
  byProductData: { product: string; litres: any }[];
  paymentStatus: { status_label: string; count: any }[] = [];
  totaltodaycostzone: ZoneData = {};
  totaltodaycostunion: UnionData = {};
  combinedZoneData: {
    zone_name: string;
    yesterday_total_cost: number;
    today_total_cost: number;
  }[] = [];
  combinedUnionData: {
    union_name: string;
    yesterday_total_cost: number;
    today_total_cost: number;
  }[] = [];
  totalyesterdaycostzone: any;
  totalyesterdaycostunion: any;
  combineUnionData: any;
  selectedSummary: "today" | "yesterday" = "today";

  extractCostData(yesterdayCostData: any, todayCostData: any): any[] {
    const result = [];

    for (const key in yesterdayCostData) {
      if (
        yesterdayCostData.hasOwnProperty(key) ||
        todayCostData.hasOwnProperty(key)
      ) {
        result.push({
          zoneName: key,
          yesterdayCost: yesterdayCostData[key] || 0,
          todayCost: todayCostData[key] || 0,
        });
      }
    }

    return result;
  }
  constructor(private http: HttpService) {
    {
      const data_dict = {
        selected_option: "today",
      };
    }
  }

  ngOnInit(): void {
    const data_dict = {
      selected_option: "today",
    };
    this.http.getdashboarddata(data_dict).subscribe((data: any) => {
      console.info(data);
      this.dashboard_details = data;
      this.walletData = data.Wallet;
      this.paymentStatus = data.payment_status;
      this.byProductData = data.ByProduct; // Assign the data to your paymentStatus property
      this.productLitres = data.Milk;
      this.productcurdtLitres = data.Curd;
      this.byProductData = data.ByProduct;
      this.no_of_orders_tc = this.dashboard_details["totalorders_by_all"];
      this.no_of_agents_tc = this.dashboard_details["total_orders_by_agent"]; // totalyesterdaycostzone: { product: string; litres: any; }[];
      this.no_of_cardcust_tc =
        this.dashboard_details["total_orders_by_card_customers"];
      this.no_of_employee_tc =
        this.dashboard_details["total_orders_by_employees"];
      this.no_of_ex_employee_tc =
        this.dashboard_details["total_orders_by_ex_employees"];
      this.productLitres = Object.keys(this.dashboard_details.Milk).map(
        (product) => ({
          product,
          litres: this.dashboard_details.Milk[product],
        })
      );
      this.productCurdLitres = Object.keys(this.dashboard_details.Curd).map(
        (product) => ({
          product,
          litres: this.dashboard_details.Curd[product],
        })
      );
      // Extract and transform the "ByProduct" data into the required format
      this.byProductData = Object.keys(this.dashboard_details.ByProduct).map(
        (product) => ({
          product,
          litres: this.dashboard_details.ByProduct[product],
        })
      );
      this.totalyesterdaycostzone = data.zone_yesterdays_total_cost;
      this.totaltodaycostzone = data.zone_todays_total_cost;
      this.totalyesterdaycostunion = data.union_yesterdays_total_cost;
      this.totaltodaycostunion = data.union_todays_total_cost;
      this.totalyesterdaycostzone = data.zone_yesterdays_total_cost || [];
      this.totaltodaycostzone = data.zone_todays_total_cost || [];
      this.combinedZoneData = this.combineData(
        this.totalyesterdaycostzone,
        this.totaltodaycostzone
      );
      this.combinedUnionData = this.combineData(
        this.totalyesterdaycostunion,
        this.totaltodaycostunion
      );
      this.combinedZoneData = this.combineData(
        data.zone_yesterdays_total_cost,
        data.zone_todays_total_cost
      );
      // this.combinedUnionData = this.combineData(
      //   data.union_yesterdays_total_cost,
      //   data.union_todays_total_cost
      // );
      this.totalyesterdaycostunion = data.union_yesterdays_total_cost || {};
      this.totaltodaycostunion = data.union_todays_total_cost || {};
      this.combinedUnionData = this.combineData(
        this.totalyesterdaycostunion,
        this.totaltodaycostunion
      );
      this.combinedZoneData = this.combineZoneData(
        this.totalyesterdaycostzone,
        this.totaltodaycostzone
      );
      // this.combinedUnionData = this.combineUnionData(
      //   this.totalyesterdaycostunion,
      //   this.totaltodaycostunion
      // );
      this.myForm = this.formBuilder.group({
        selectedOption: [null, Validators.compose([Validators.required])],
      });
      this.totalLitersMilk = this.productLitres.reduce(
        (total, item) => total + item.litres,
        0
      );
      this.totalLitersCurd = this.productcurdtLitres.reduce(
        (total, item) => total + item.litres,
        0
      );
      this.totalLitersByproduct = this.byProductData.reduce(
        (total, item) => total + parseFloat(item.litres),
        0
      );
      for (const item of this.byProductData) {
        this.totalLitersByproduct += parseFloat(item.litres);
      }
    });
  }

  combineData(yesterdayData: ZoneData, todayData: ZoneData | UnionData): any[] {
    const combinedData = [];

    for (const key in yesterdayData) {
      if (yesterdayData.hasOwnProperty(key)) {
        combinedData.push({
          union_name: key, // Use 'union_name' for Union data
          yesterday_total_cost: yesterdayData[key],
          today_total_cost: todayData[key] || 0,
        });
      }
    }

    return combinedData;
  }
  combineZoneData(yesterdayData: ZoneData, todayData: ZoneData): any[] {
    const combinedData = [];

    for (const key in yesterdayData) {
      if (yesterdayData.hasOwnProperty(key)) {
        combinedData.push({
          zone_name: key,
          yesterday_total_cost: yesterdayData[key],
          today_total_cost: todayData[key] || 0,
        });
      }
    }

    return combinedData;
  }

  calculateTotalYesterdayCostZone(): number {
    const totalCost = this.combinedZoneData.reduce(
      (total, item) => total + item.yesterday_total_cost,
      0
    );
    return totalCost;
  }

  calculateTotalTodayCostZone(): number {
    const totalCost = this.combinedZoneData.reduce(
      (total, item) => total + item.today_total_cost,
      0
    );
    return totalCost;
  }

  calculateTotalYesterdayCostUnion(): number {
    const totalCost = this.combinedUnionData.reduce(
      (total, item) => total + item.yesterday_total_cost,
      0
    );
    return totalCost;
  }

  calculateTotalTodayCostUnion(): number {
    const totalCost = this.combinedUnionData.reduce(
      (total, item) => total + item.today_total_cost,
      0
    );
    return totalCost;
  }

  toggleReport() {
    const selectedData =
      this.buttonText === "Show Yesterday's Report" ? "yesterday" : "today";
    if (this.buttonText === "Show Yesterday's Report") {
      this.buttonText = "Show Today's Report";
      this.headerText = "Yesterday's Summary Report";
    } else {
      this.buttonText = "Show Yesterday's Report";
      this.headerText = "Today's Summary Report";
    }

    const data_dict = {
      selected_option: selectedData,
    };
    // const selectedData = { selected_option: 'yesterday' };
    this.http
      .getdashboarddata({ selected_option: selectedData })
      .subscribe((data: any) => {
        console.info(data);
        this.dashboard_details = data;
        this.walletData = data.Wallet;
        this.paymentStatus = data.payment_status;
        this.byProductData = data.ByProduct; // Assign the data to your paymentStatus property
        this.productLitres = data.Milk;
        this.productcurdtLitres = data.Curd;
        this.byProductData = data.ByProduct;
        this.no_of_orders_tc = this.dashboard_details["totalorders_by_all"];
        this.no_of_agents_tc = this.dashboard_details["total_orders_by_agent"]; // totalyesterdaycostzone: { product: string; litres: any; }[];
        this.no_of_cardcust_tc =
          this.dashboard_details["total_orders_by_card_customers"];
        this.no_of_employee_tc =
          this.dashboard_details["total_orders_by_employees"];
        this.no_of_ex_employee_tc =
          this.dashboard_details["total_orders_by_ex_employees"];
        this.productLitres = Object.keys(this.dashboard_details.Milk).map(
          (product) => ({
            product,
            litres: this.dashboard_details.Milk[product],
          })
        );
        this.productCurdLitres = Object.keys(this.dashboard_details.Curd).map(
          (product) => ({
            product,
            litres: this.dashboard_details.Curd[product],
          })
        );
        // Extract and transform the "ByProduct" data into the required format
        this.byProductData = Object.keys(this.dashboard_details.ByProduct).map(
          (product) => ({
            product,
            litres: this.dashboard_details.ByProduct[product],
          })
        );
        this.totalyesterdaycostzone = data.zone_yesterdays_total_cost;
        this.totaltodaycostzone = data.zone_todays_total_cost;
        this.totalyesterdaycostunion = data.union_yesterdays_total_cost;
        this.totaltodaycostunion = data.union_todays_total_cost;
        this.totalyesterdaycostzone = data.zone_yesterdays_total_cost || [];
        this.totaltodaycostzone = data.zone_todays_total_cost || [];
        this.combinedZoneData = this.combineData(
          this.totalyesterdaycostzone,
          this.totaltodaycostzone
        );
        this.combinedUnionData = this.combineData(
          this.totalyesterdaycostunion,
          this.totaltodaycostunion
        );
        this.combinedZoneData = this.combineData(
          data.zone_yesterdays_total_cost,
          data.zone_todays_total_cost
        );
        // this.combinedUnionData = this.combineData(
        //   data.union_yesterdays_total_cost,
        //   data.union_todays_total_cost
        // );
        this.totalyesterdaycostunion = data.union_yesterdays_total_cost || {};
        this.totaltodaycostunion = data.union_todays_total_cost || {};
        this.combinedUnionData = this.combineData(
          this.totalyesterdaycostunion,
          this.totaltodaycostunion
        );
        this.combinedZoneData = this.combineZoneData(
          this.totalyesterdaycostzone,
          this.totaltodaycostzone
        );
        // this.combinedUnionData = this.combineData(
        //   this.totalyesterdaycostunion,
        //   this.totaltodaycostunion
        // );
        this.myForm = this.formBuilder.group({
          selectedOption: [null, Validators.compose([Validators.required])],
        });
        this.totalLitersMilk = this.productLitres.reduce(
          (total, item) => total + item.litres,
          0
        );
        this.totalLitersCurd = this.productcurdtLitres.reduce(
          (total, item) => total + item.litres,
          0
        );
        this.totalLitersByproduct = this.byProductData.reduce(
          (total, item) => total + parseFloat(item.litres),
          0
        );
        for (const item of this.byProductData) {
          this.totalLitersByproduct += parseFloat(item.litres);
        }
      });
  }
  formatNumberWithCommas(amount: number): string {
    const crore = Math.floor(amount / 10000000);
    const tenLakh = Math.floor((amount % 10000000) / 100000);
    const lakh = Math.floor((amount % 100000) / 1000);
    const remainder = amount % 1000;

    const formattedAmount = `${crore ? crore + "," : ""}${tenLakh ? tenLakh + "," : ""
      }${lakh ? lakh + "," : ""}${remainder.toFixed(2)}`;

    return formattedAmount;
  }
}
